import { createFetchBaseQuery } from "@holigral/shared/api"
import type { State as AuthState } from "@/auth/slice"

type BaseQueryOptions = {
  withoutAuth: boolean
}

export default ({ withoutAuth }: BaseQueryOptions) =>
  createFetchBaseQuery({
    prepareHeaders: (headers, { getState }) => {
      const { token, tenantSlug } = (getState() as { auth: AuthState }).auth

      if (!withoutAuth && token) {
        headers.set("Authorization", `Bearer ${token}`)
      }
      if (tenantSlug) {
        headers.set("Tenant-Slug", tenantSlug)
      }
    },
  })
